import { getDashboardProductImageSrc } from "@/lib/productImageUrl";

type PaymentMethodIconProps = {
	iconUrl: string;
	alt?: string;
	className?: string;
};

export function PaymentMethodIcon({ iconUrl, alt = "", className = "h-8 w-8 shrink-0 object-contain" }: PaymentMethodIconProps) {
	const src = getDashboardProductImageSrc(iconUrl);
	if (!src) return null;
	return <img src={src} alt={alt} className={className} loading="lazy" />;
}
